import i18n from '@/i18n';

/**
 * Shell words read OUTSIDE a component render — the role labels in
 * `ROLE_DISPLAY` and the unread chip's words (#2109). They resolve through
 * the i18next singleton at call time, so a language change reaches them on
 * the next render. The bound function is named `t` on purpose: the
 * `i18next-cli` extractor only sees calls to `t(...)`, and a key it cannot
 * see is never written to the target catalogs.
 */
const t = i18n.t.bind(i18n);

export const roleLabels = {
  admin: () => t('shell:roles.admin'),
  trfer: () => t('shell:roles.trfer'),
  parent: () => t('shell:roles.parent'),
  applicant: () => t('shell:roles.applicant'),
} as const;

/** "3 unread" — the number and the word, one plural key. */
export const unreadWords = (count: number) => t('shell:sidebar.unread', { count });
